import { environment } from "../../environments/environment";

export class AppConfig {
    static readonly STRIPE_KEY: string = environment.stripeKey
    static readonly HOST: string =  "https://core.evabot.com/"; 
    //static readonly HOST: string = "http://localhost:8000/";
   // static readonly HOST: string = "https://invoice.evabot.ai/";
}       